module.exports = __webpack_public_path__ + "b3d7ab53fa7732c6c1e710d847114102.png";